import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import BillsAccountsCell from './BillsAccountsCell';

const PartnerAccountsRow = ({ keyName, data }) => {
  //console.log(JSON.stringify(data));

  if (!keyName && !data) {
    return null;
  }

  return (
    data &&
    data.map((partner, iIndex) => {
      let key = partner.id + iIndex;

      return (
        <TableRow key={key}>
          <TableCell sx={{ width: 80, textAlign: 'center' }}>
            {partner.id}
          </TableCell>
          <TableCell>{partner.partnerNm}</TableCell>
          <BillsAccountsCell data={partner[keyName]} />
        </TableRow>
      );
    })
  );
};

export default PartnerAccountsRow;
